import {
  Alert,
  AlertDescription,
  AlertIcon,
  Stack,
  Text,
} from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { getSubscriptionsCompatibleWithHolders } from "../../../helpers/subscriptions/getSubscriptionsCompatibleWithHolders";
import SubscriptionsBatchCard from "./Card";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Subscription").Subscription[]} subscriptions
 * @property {import("@raiden/library/types/Holder").Holder[]} holders
 * @property {import("./Handler").SubscriptionsData} subscriptionsData
 * @property {(params: {subscriptionId: string, holderIds: string[]}) => void} upsertSubscriptionData
 * @property {(params: {subscriptionId: string}) => void} deleteSubscriptionData
 *
 * @param {Props} props
 */
function SubscriptionsBatchForm({
  subscriptions,
  holders,
  subscriptionsData,
  upsertSubscriptionData,
  deleteSubscriptionData,
}) {
  return (
    <>
      {holders.length === 0 && (
        <Alert status="info">
          <AlertIcon />

          <AlertDescription>
            <Text>
              <FormattedMessage defaultMessage="Aucun adhérent n'a été trouvé sur ce compte." />
            </Text>
          </AlertDescription>
        </Alert>
      )}

      <Stack spacing="1rem">
        {getSubscriptionsCompatibleWithHolders({
          subscriptions,
          holders,
        }).map((subscription) => {
          return (
            <SubscriptionsBatchCard
              subscription={subscription}
              holders={holders}
              initialHolderIds={
                subscriptionsData.find(
                  (subscriptionData) =>
                    subscriptionData.subscriptionId === String(subscription.id),
                )?.holderIds
              }
              upsertSubscriptionData={upsertSubscriptionData}
              deleteSubscriptionData={deleteSubscriptionData}
              isSelected={subscriptionsData.some(
                (subscriptionData) =>
                  subscriptionData.subscriptionId === String(subscription.id),
              )}
              key={subscription.id}
            />
          );
        })}
      </Stack>
    </>
  );
}

export default SubscriptionsBatchForm;
